import { useNavigate, type NavigateOptions, type To } from 'react-router'

type PushReplaceOptions = Omit<NavigateOptions, 'replace'>

let _nav: ReturnType<typeof useNavigate>

type Router = {
  push: (to: To, options?: PushReplaceOptions) => void
  replace: (to: To, options?: PushReplaceOptions) => void
  back: (delta?: number) => void
}

// 多包了一層 Proxy，是為了避免每次 push 都因為用了 useNavigate 而觸發重新渲染
export const router = new Proxy({} as Router, {
  get(target, prop) {
    switch (prop) {
      case 'push':
        return async (to: To, options?: PushReplaceOptions) => {
          await _nav(to, options)
        }
      case 'replace':
        return async (to: To, options?: PushReplaceOptions) => {
          await _nav(to, { ...options, replace: true })
        }
      case 'back':
        return () => _nav(-1)
      default:
        return undefined
    }
  },
})

export const NavProvider = () => {
  _nav = useNavigate()
  return null
}
